import React from "react";
import { Image, View } from "react-native";

import { Typography } from "@smartrent/ui";

import notFoundImage from "@/assets/images/404.svg";

export default function NotFound({
  message = "Page Not Found",
}: {
  message?: string;
}) {
  const ratio = 0.997767857;

  return (
    <View
      style={{
        flex: 1,
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Image
        source={notFoundImage}
        style={{
          width: 300,
          height: 300 / ratio,
        }}
      />
      <Typography
        type="title2"
        color="textPrimary"
        style={{
          marginTop: 16,
        }}
      >
        {message}
      </Typography>
    </View>
  );
}
